export type LeaderboardEntry = { playerId: string; playerName: string; score: number };

/**
 * Sync a local player list from an authoritative backend leaderboard.
 *
 * The server builds leaderboards from getStandingsPlayers() (intentionally-left
 * players excluded). The leaderboard is the roster + scores; we preserve avatars
 * from the current list and do not keep local-only players that left.
 */
export function syncPlayersFromLeaderboard<
  T extends { id: string; name: string; score: number; avatar?: string },
>(currentPlayers: T[], leaderboard: LeaderboardEntry[] | undefined): T[] {
  if (!Array.isArray(leaderboard) || leaderboard.length === 0) {
    return currentPlayers;
  }
  const currentById = new Map(currentPlayers.map((p) => [p.id, p]));
  return leaderboard.map((entry) => {
    const existing = currentById.get(entry.playerId);
    return {
      id: entry.playerId,
      name: entry.playerName,
      score: entry.score,
      avatar: existing?.avatar,
    } as T;
  });
}
